import React, { useState, useEffect, useContext } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import update from "immutability-helper";
import styled from "styled-components";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import {
  CLIENT_EVENT_TYPE_LIST_QUERY,
  DELETE_EVENT_TYPE_MUTATION,
  LATEST_CLIENT_EVENT_TYPE_BY_UPDATE_DATE_QUERY,
} from "../../graphQL/event_type_qry";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import AlertDialog from "../../components/AlertDialog.js";

import ManageEventTypeInputsDialog from "../../components/ManageEventTypeInputsDialog.js";

import { project_url } from "../../constants/Data";

import Header from "./HeaderWithClient.js";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    //  paddingTop:theme.spacing(2),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },

  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    // "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
    //   position: "relative",
    //   display: "block",
    // },
    "&.MuiDataGrid-root": {
      //paddingTop:10,
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function ManageEventTypes() {
  //const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const [loadList, setLoadList] = useState(false);

  const [pageSize, setPageSize] = useState(20);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [eventTypeData, setEventTypeData] = useState([]);

  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [manageEventTypeInputsDialogMsg, setManageEventTypeInputsDialogMsg] = useState(
    []
  );
  const [alertDoneMsg, setAlertDoneMsg] = useState([]);
  const [lastUpdate, setLastUpdate] = useState("");

  const [deleteEventTypeMutation] = useMutation(DELETE_EVENT_TYPE_MUTATION, {
    fetchPolicy: "network-only",
  });

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  let loadData = true;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");
  if (clientId == 0)
    loadData = false;

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Manage Event Types"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };
  const [getTenantEventTypeData] = useManualQuery(CLIENT_EVENT_TYPE_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  const [getLatestEventTypeByUpdateDate] = useManualQuery(
    LATEST_CLIENT_EVENT_TYPE_BY_UPDATE_DATE_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  function checkDeleteStatus(row) {
    if (row.deletable === true)
      setAlertDeleteMsg({
        title: "Delete Event Type",
        msg: "This event type is used in an event. It cannot be deleted.",
      });
    else
      setAlertDeleteMsg({
        title: "Delete Event Type",
        type: "deleteConfirmation",
        msg: 'Are you sure you want to delete the event type "' + row.name + '"?',
        eventTypeId: row.index,
      });
  }

  const deleteEventType = async eventTypeId => {
    setLoadList(false);
    const {
      loading: loadingEventTypeDelete,
      error: errorEventTypeDelete,
      data: dataEventTypeDelete,
    } = await deleteEventTypeMutation({
      variables: {
        eventTypeId: parseInt(eventTypeId),
      },
    });
    if (
      !loadingEventTypeDelete &&
      dataEventTypeDelete &&
      dataEventTypeDelete.deleteEventType
    ) {
      setLoadList(true);
    }
    if (errorEventTypeDelete) {
      if (errorEventTypeDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else alert(errorEventTypeDelete.graphQLErrors[0].message);
    }
  };

  const getEventTypeList = async () => {
    // Get event type list
    const {
      loading: eventTypeDataLoading,
      error: eventTypeDataError,
      data: eventTypeData,
    } = await getTenantEventTypeData({
      variables: {
        clientId: parseInt(clientId),
      },
    });

    if (!eventTypeDataLoading && eventTypeData && eventTypeData.clientEventTypeList) {
      setEventTypeData(eventTypeData.clientEventTypeList);

      // Get latest event type
      const {
        loading: eventTypeLoading,
        error: eventTypeError,
        data: eventType,
      } = await getLatestEventTypeByUpdateDate({
        variables: {
          clientId: parseInt(clientId),
        },
      });

      if (!eventTypeLoading && eventType && eventType.latestClientEventTypeByUpdateDate)
        setLastUpdate(dayFormat(eventType.latestClientEventTypeByUpdateDate.updateDate));
      else setLastUpdate("");

      loadData = true;
      setLoadList(false);
      setManageEventTypeInputsDialogMsg([]);
    }
    else 
      loadData = false;

    if (
      eventTypeDataError &&
      eventTypeDataError.graphQLErrors &&
      eventTypeDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
    console.log("eventTypeData", eventTypeData);
  };

  const rows = eventTypeData.map(eventType => ({
    index: eventType.eventTypeId,
    name: eventType.name,
    desc: eventType.desc,
    deletable: eventType.deletable,
    editAccess : editAccess,
    deleteAccess: deleteAccess,
  }));

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getEventTypeList())();
  }, [loadList]);

  const columns = [
    {
      field: "name",
      headerName: "Event Type Name",
      minWidth: 200,
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: "desc",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";

        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Edit">
              <img
                style={{
                  paddingRight: 15,
                  cursor: editCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: editFilter,
                  opacity: editOpacity,
                }}
                src={penImg}
                onClick={() =>
                rows.row.editAccess ?
                  (
                    setManageEventTypeInputsDialogMsg({
                      title: "Edit Event Type",
                      index: rows.row.index,
                      values: [rows.row.name, rows.row.desc],
                      msg: ["Event Type Name", "Description"],
                      type: "Edit",
                    })
                  )
                  :""
                }
              />
            </StyledTooltip>
            <StyledTooltip title="Delete">
              <img
                style={{
                  paddingRight: 15,
                  cursor: deleteCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: deleteFilter,
                  opacity: deleteOpacity,
                }}
                src={trashImg}
                onClick={() => rows.row.deleteAccess ? checkDeleteStatus(rows.row) : ""}
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  const classes = useStyles();
  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="body1">Manage Event Type</Typography>
            <Typography variant="h5" style={{ paddingLeft: 10, paddingTop: 3 }}>
              {lastUpdate !== "" ? <>(Last Updated: {lastUpdate})</> : ""}
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled = {!addAccess ? "disabled" : ""}
              onClick={() =>
              addAccess ?
                (
                  setManageEventTypeInputsDialogMsg({
                    title: "Add Event Type",
                    index: 0,
                    msg: ["Event Type Name", "Description"],
                    type: "Add",
                  })
                )
                :""
              }
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }

  
  if (loadContent)
    if (loadData)
    if (access)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: "General Settings", link: null },
            { label: "Manage Event Types", link: null },
          ]}
        />
        <div className={classes.container}>
          <Box mb={3} />
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            getRowId={row => row.index}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 20 } },
            }}
            pageSizeOptions={[20, 50, 100]}
          />

          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteEventType(alertDeleteMsg.eventTypeId);
              }}
            />
          )}
          {manageEventTypeInputsDialogMsg.msg && (
            <ManageEventTypeInputsDialog
              title={manageEventTypeInputsDialogMsg.title}
              text={manageEventTypeInputsDialogMsg.text}
              values={manageEventTypeInputsDialogMsg.values}
              data={eventTypeData}
              index={manageEventTypeInputsDialogMsg.index}
              type={manageEventTypeInputsDialogMsg.type}
              contentMsg={manageEventTypeInputsDialogMsg.msg}
              closeDialog={() => setManageEventTypeInputsDialogMsg([])}
              addEditDialog={values => {
                setLoadList(true);
              }}
            />
          )}
          {alertDoneMsg.msg && (
            <AlertDialog
              title={alertDoneMsg.title}
              contentMsg={alertDoneMsg.msg}
              closeDialog={() => navigate(`${project_url}/tenant/dashboard`)}
            />
          )}
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Client"
                contentMsg='There is no client in this Tenant. Please create a client.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default ManageEventTypes;
